var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import clsx from 'clsx';
import { ListGroupItem } from 'reactstrap';
import styled from 'styled-components';
import IndicatorButton from './IndicatorButton'; // styled reactstrap list group item

var IndicatorListGroupItem = styled(ListGroupItem)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  border: none;\n  padding: 0;\n"])));

var IndicatorListItem = function IndicatorListItem(_ref) {
  var indicator = _ref.indicator,
      _ref$showHint = _ref.showHint,
      showHint = _ref$showHint === void 0 ? true : _ref$showHint,
      onSelect = _ref.onSelect,
      activeId = _ref.activeId,
      children = _ref.children;

  var handleClick = function handleClick(e) {
    onSelect && onSelect(indicator, e);
  };

  return /*#__PURE__*/React.createElement(IndicatorListGroupItem, null, /*#__PURE__*/React.createElement(IndicatorButton, {
    indicator: indicator,
    showHint: showHint,
    onClick: handleClick,
    active: indicator.id === activeId
  }), children);
};

export default IndicatorListItem;